<div class="head">
  <h1 class="page-title">Reports</h1>
  <div class="view-toggle">
    <button class="btn" [class.on]="view === 'month'" (click)="setView('month')">Month</button>
    <button class="btn" [class.on]="view === 'year'" (click)="setView('year')">Year</button>
  </div>
</div>

<p class="loading" *ngIf="loading">Loading…</p>
<p class="error" *ngIf="error">{{ error }}</p>

<ng-container *ngIf="!loading && !error && view === 'month'">
  <select class="picker" [ngModel]="month" (ngModelChange)="setMonth($event)">
    <option *ngFor="let m of months" [value]="m">{{ m + '-01T00:00:00' | date:'MMMM yyyy' }}</option>
  </select>

  <p class="empty" *ngIf="!month">No transactions yet — add some on the Import or Transactions screen.</p>

  <ng-container *ngIf="month">
  <div class="stats" *ngIf="headline">
    <div class="stat">
      <div class="v num">{{ fmt(headline.income.cents) }}</div>
      <div class="k">income</div>
      <div class="vs num" *ngIf="headline.income.prevCents !== null">prev {{ fmt(headline.income.prevCents) }}</div>
      <div class="vs num" *ngIf="headline.income.yoyCents !== null">yr ago {{ fmt(headline.income.yoyCents) }}</div>
    </div>
    <div class="stat">
      <div class="v num">{{ fmt(headline.spending.cents) }}</div>
      <div class="k">spending</div>
      <div class="vs num" *ngIf="headline.spending.prevCents !== null">prev {{ fmt(headline.spending.prevCents) }}</div>
      <div class="vs num" *ngIf="headline.spending.yoyCents !== null">yr ago {{ fmt(headline.spending.yoyCents) }}</div>
    </div>
    <div class="stat">
      <div class="v num" [class.neg]="headline.net.cents < 0">{{ fmt(headline.net.cents) }}</div>
      <div class="k">net</div>
      <div class="vs num" *ngIf="headline.net.prevCents !== null">prev {{ fmt(headline.net.prevCents) }}</div>
    </div>
    <div class="stat">
      <div class="v num">{{ headline.savingsRatePct !== null ? headline.savingsRatePct + '%' : '—' }}</div>
      <div class="k">savings rate</div>
    </div>
  </div>

  <div class="lbl second">Spending by group</div>
  <table class="report-table">
    <thead><tr><th></th><th class="num">this month</th><th class="num">last month</th><th class="num">6-mo avg</th></tr></thead>
    <tbody>
      <ng-container *ngFor="let g of groupLines; trackBy: trackGroup">
        <tr class="group-row">
          <th scope="row"><span class="sw" [style.background]="g.color"></span>{{ g.name }}</th>
          <td class="num">{{ fmt(g.cents) }}</td>
          <td class="num muted">{{ fmt(g.prevCents) }}</td>
          <td class="num muted">{{ fmt(g.avg6Cents) }}</td>
        </tr>
        <tr class="cat-row" *ngFor="let c of g.categories">
          <th scope="row">{{ c.name }}</th>
          <td class="num">{{ fmt(c.cents) }}</td>
          <td class="num muted">{{ fmt(c.prevCents) }}</td>
          <td class="num muted">{{ fmt(c.avg6Cents) }}</td>
        </tr>
      </ng-container>
    </tbody>
  </table>

  <div class="cols">
    <div>
      <div class="lbl second">Bills</div>
      <p class="empty" *ngIf="!split.bills.length">No recurring bills matched this month.</p>
      <div class="m-row" *ngFor="let m of split.bills; trackBy: trackStem">
        <span class="name">{{ m.display }}</span>
        <span class="amt num">{{ fmt(m.cents) }}</span>
      </div>
    </div>
    <div>
      <div class="lbl second">Everyday spending</div>
      <p class="empty" *ngIf="!split.everyday.length">No everyday spending this month.</p>
      <div class="m-row" *ngFor="let m of split.everyday; trackBy: trackStem">
        <span class="name">{{ m.display }}</span>
        <span class="count">×{{ m.count }}</span>
        <span class="amt num">{{ fmt(m.cents) }}</span>
      </div>
    </div>
  </div>

  <div class="lbl second">Largest transactions</div>
  <p class="empty" *ngIf="!largest.length">No spending this month.</p>
  <div class="m-row" *ngFor="let t of largest; trackBy: trackTxn">
    <span class="date num">{{ t.date + 'T00:00:00' | date:'MMM d' }}</span>
    <span class="name">{{ t.description }}</span>
    <span class="amt num">{{ fmt(t.amount) }}</span>
  </div>
  </ng-container>
</ng-container>

<p class="empty" *ngIf="!loading && !error && view === 'year' && !year">
  Nothing to report yet — import a CSV to get started.
</p>

<ng-container *ngIf="!loading && !error && view === 'year' && year">
  <select class="picker" [ngModel]="year" (ngModelChange)="setYear($event)">
    <option *ngFor="let y of years" [value]="y">{{ y }}</option>
  </select>

  <div class="stats" *ngIf="yHeadline">
    <div class="stat">
      <div class="v num">{{ fmt(yHeadline.incomeCents) }}</div><div class="k">income</div>
      <div class="vs num">{{ fmt(yHeadline.avgIncomeCents) }}/mo</div>
    </div>
    <div class="stat">
      <div class="v num">{{ fmt(yHeadline.spendingCents) }}</div><div class="k">spending</div>
      <div class="vs num">{{ fmt(yHeadline.avgSpendingCents) }}/mo</div>
    </div>
    <div class="stat">
      <div class="v num" [class.neg]="yHeadline.netCents < 0">{{ fmt(yHeadline.netCents) }}</div><div class="k">net</div>
      <div class="vs num">{{ fmt(yHeadline.avgNetCents) }}/mo</div>
    </div>
    <div class="stat">
      <div class="v num">{{ yHeadline.monthsPresent.length }}</div>
      <div class="k">of 12 months</div>
    </div>
  </div>

  <div class="lbl second">Net by month</div>
  <mm-line [points]="yNetPoints" [displayValues]="yNetDisplay"
           [areaFill]="false"
           [ariaLabel]="year + ' net by month'"></mm-line>

  <div class="lbl second">Categories · {{ year }}</div>
  <table class="report-table">
    <thead><tr><th></th><th class="num">{{ year }}</th><th class="num">prior</th><th class="num">Δ</th></tr></thead>
    <tbody>
      <tr *ngFor="let r of yCategories; trackBy: trackYearCat">
        <th scope="row">{{ r.name }}<span class="grp"> · {{ r.groupName }}</span></th>
        <td class="num">{{ fmt(r.cents) }}</td>
        <td class="num muted">{{ r.prevCents !== null ? fmt(r.prevCents) : '—' }}</td>
        <td class="num muted" [title]="r.comparedLabel ?? ''">
          {{ r.deltaPct !== null ? (r.deltaPct > 0 ? '+' : '') + r.deltaPct + '%' : '—' }}
        </td>
      </tr>
    </tbody>
  </table>
  <p class="hint" *ngIf="yCoverageNote">{{ yCoverageNote }}</p>
  <p class="hint" *ngIf="!yCoverageNote && yCategories.length && yCategories[0].comparedLabel">
    Δ is {{ yCategories[0].comparedLabel }} — the same months, so a partial year compares fairly.
  </p>

  <div class="cols">
    <div>
      <div class="lbl second">Bills</div>
      <p class="empty" *ngIf="!ySplit.bills.length">No recurring bills matched this year.</p>
      <div class="m-row" *ngFor="let m of ySplit.bills; trackBy: trackStem">
        <span class="name">{{ m.display }}</span><span class="amt num">{{ fmt(m.cents) }}</span>
      </div>
    </div>
    <div>
      <div class="lbl second">Everyday spending</div>
      <p class="empty" *ngIf="!ySplit.everyday.length">No everyday spending this year.</p>
      <div class="m-row" *ngFor="let m of ySplit.everyday; trackBy: trackStem">
        <span class="name">{{ m.display }}</span>
        <span class="count">×{{ m.count }}</span>
        <span class="amt num">{{ fmt(m.cents) }}</span>
      </div>
    </div>
  </div>
</ng-container>
